import { ROUTES } from "~/constant"

const isLightMode = () => {
  const PagesWithLightMode = [ROUTES.PRESS]
  return PagesWithLightMode.includes(window.location.pathname)
}

export default isLightMode
